import React, { useState, useRef, useEffect } from "react";
import "./Navbar.css";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Clock, LayoutDashboard } from "lucide-react";
import { Icon } from "@iconify/react";
import { LightDark } from "../../Assets/CSS/Text";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";

// const getUserRole = () => {
//   const roles = localStorage.getItem("roles");
//   return roles ? roles.split(",") : [];
// };

export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || [];   // roles array from token
    const employeeFullName = decoded.employeeFullName || decoded.sub || null; // subject claim
    console.log(".................", employeeFullName)
    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, employeeFullName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};
const Navbar = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); // Added for mobile menu toggle
  const dropdownRef = useRef(null);
  const token = localStorage.getItem("token");
  const { roles = [], employeeFullName } = getUserRole(token); // default to empty array
  const [showLogoutPrompt, setShowLogoutPrompt] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const toggleDropdown = () => {
    console.log("Dropdown clicked");
    setDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    setLogoutLoading(true); // show spinner

    localStorage.clear();
    toast.success("Logout Successfully")
    setTimeout(() => {
      navigate('/');
      setLogoutLoading(false); // in case you want to reuse the button later
    }, 1000)
    // Add your logout logic here (e.g., redirect to login page)
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const roleRoutes = {
    ROLE_ADMIN: [
      { path: "/employee-dashboard", label: "Employee Dashboard" },
      { path: "/admin-dashboard", label: "Admin Dashboard" },
      { path: "/timesheet", label: "My Timesheet" },
      { path: "/admin-timesheet", label: "Employee's Timesheet" },
      { path: "/leave-management", label: "Leave Management" },
      { path: "/emp-management", label: "Employee Manager" },
      { path: "/emp-onbaord", label: "Employee Onboarding" },
      { path: "/deptrole", label: "Department & Role" },
      { path: "/annexure-salary", label: "CMS" },
      { path: "/off-boarding", label: "Offboarding" },
    ],
    ROLE_SYSTEM_ADMIN: [
      { path: "/admin-dashboard", label: "Dashboard" },
      { path: "/admin-timesheet", label: "Employee's Timesheet" },
      { path: "/leave-management", label: "Leave Management" },
      { path: "/emp-management", label: "Employee Manager" },
      { path: "/emp-onbaord", label: "Employee Onboarding" },
      { path: "/deptrole", label: "Department & Role" },
      { path: "/annexure-salary", label: "CMS" },
      { path: "/off-boarding", label: "Offboarding" },
    ],
    ROLE_HR: [
      { path: "/admin-dashboard", label: "HR Dashboard" },
      { path: "/leave-managment", label: "Leave Management" },
    ],
    ROLE_EMP: [
      { path: "/employee-dashboard", label: "Dashboard" },
      { path: "/timesheet", label: "Timesheet" },
      { path: "/leave-managment", label: "Leave Management" },
    ],
    ROLE_MANAGER: [
      { path: "/employee-dashboard", label: "Dashboard" },
      { path: "/admin-timesheet", label: "Employee's Timesheet" },
      { path: "/timesheet", label: "My Timesheet" },
      { path: "/leave-management", label: "Leave Management" }, ,
    ],
  };
  const allRoutes = roles.flatMap((role) => roleRoutes[role] || []);
  const dedupedRoutes = Array.from(
    new Map(allRoutes.map((item) => [item.path, item])).values()
  );
  // const employeeFullName = localStorage.getItem("employeeFullName");

  console.log("UserName", employeeFullName)

  return (
    <div className="">
      <nav className="navbar">
        <div className="navbar-left">
          {/* Hamburger icon for small screens */}
          <button className="menu-icon" onClick={toggleMenu}>
            <Icon icon="material-symbols:menu-rounded" width="22" height="22" />
          </button>
          <img
            src={require("../../Assets/Images/EMS-logo.png")}
            alt="Company Logo"
            className="navbar-logo"
          />
        </div>
        <div className="navbar-right">
          <div
            className={`profile-dropdown ${dropdownOpen ? "open" : ""}`}
            ref={dropdownRef}
            onClick={toggleDropdown}
          >
            {/* <img
            src={require("../../Assets/Images/man.png")}
            alt="User Profile"
            className="navbar-user-img"
          /> */}
            <div
              className="rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "40px",
                height: "40px",
                fontSize: "12px",
                color: "#999",
                backgroundColor: "#F0F0F0",
                border: "1px solid #F0F0F0 ",
              }}
            >
              <Icon icon="proicons:person" className="fs-4 " style={{}} />
            </div>
            <span className="navbar-user-name">{employeeFullName}</span>
            <Icon icon="mdi:chevron-down" className="navbar-dropdown-icon" />

            {dropdownOpen && (
              <div className="dropdown-menu">
                <ul>
                  <li
                    onClick={() => {
                      navigate("/profile");
                    }}
                    className="text-decoration-none d-flex justify-content-evenly align-item-center"
                    style={LightDark}
                  >
                    <span
                      className="rounded-circle d-flex justify-content-center align-items-center"
                      style={{
                        width: "32px",
                        height: "32px",
                        fontSize: "12px",
                        color: "#999",
                        backgroundColor: "#F0F0F0",
                        border: "1px solid #F0F0F0 ",
                      }}
                    >
                      <Icon
                        icon="proicons:person"
                        className="fs-5 "
                        style={{ color: "#909090" }}
                      />
                    </span>
                    {/* <Icon icon="proicons:person" className="fs-4 " style={{ color: '#909090' }} /> */}
                    Profile
                  </li>
                  <li
                    onClick={() => setShowLogoutPrompt(true)}
                    className="fs-6 fw-normal d-flex justify-content-evenly align-item-center"
                    style={{ color: "#E00000" }}
                  >
                    <Icon icon="material-symbols:logout" className="fs-4" />
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* Sidebar drawer for mobile */}
        <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
          <ul>
            {dedupedRoutes.map(({ path, label }) => (
              <li key={path}>
                <NavLink to={path}>{label}</NavLink>
              </li>
            ))}
          </ul>
        </div>
        {/* overlay to close sidebar when clicking outside */}
        {menuOpen && <div className="overlay" onClick={toggleMenu}></div>}
      </nav>
      {showLogoutPrompt && (
        <div className="prompt-overlay">
          <div className="prompt-box">
            <div className="d-flex justify-content-center align-item-center">
              <div className="Loading-icon">
                <Icon
                  icon="mdi:logout"
                  className="fs-4"
                  style={{ color: "#E00000" }}
                />
              </div>
            </div>
            <h3 className="prompt-title">Confirm Logout</h3>
            <p>Are you sure you want to log out?</p>
            <div className="prompt-actions">
              <button
                onClick={() => setShowLogoutPrompt(false)}
                className="cancel-button"
              >
                Cancel
              </button>
              {/* <button onClick={handleLogout} className="confirm-button">
                Logout
              </button> */}
              <button
                onClick={handleLogout}
                className="confirm-button btn btn-danger"
                disabled={logoutLoading}
              >
                {logoutLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Logging out...
                  </>
                ) : (
                  "Logout"
                )}
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
